import React from "react";
import gs, { colors } from "gstyles";
import Link from "components/common/Link";
import MobileMenu from "../MobileMenu";

const Header = () => {
  return (
    <div className="w-full h-16 md:h-[78px]">
      <div className="fixed top-0 left-0 w-full h-[460px] bg-primary z-[-1]"></div>
      <header className="relative w-full flex items-center h-16 md:h-[78px] bg-primary">
        <div className="container mx-auto px-4 md:px-6 flex items-center justify-between">
          <div className="sm:hidden">
            <Link href="/">
              {gs.icons({
                name: "logo-black",
                width: 100,

                color: colors.white,
              })}
            </Link>
          </div>
          <div className="hidden sm:block">
            <Link href="/">
              {gs.icons({
                name: "logo-black",
                width: 140,

                color: colors.white,
              })}
            </Link>
          </div>
          <MobileMenu />
        </div>
      </header>
    </div>
  );
};

export default Header;
